export const passwords = [
  {
    id: 'pwd_001',
    organizationId: 'org_3la_labs',
    service: 'Hostinger VPS',
    username: 'admin@3lalabs',
    password: 'Demo@Hostinger2026',
    category: 'Hospedagem',
    updatedAt: '12/08/2026',
    url: 'https://hpanel.hostinger.com',
  },
  {
    id: 'pwd_002',
    organizationId: 'org_3la_labs',
    service: 'Registro.br',
    username: '3lalabs',
    password: 'Demo@Dominio2026',
    category: 'Domínios',
    updatedAt: '03/07/2026',
    url: 'https://registro.br',
  },
  {
    id: 'pwd_003',
    organizationId: 'org_3la_labs',
    service: 'Nubank PJ',
    username: 'luan@3lalabs.com.br',
    password: 'Demo@BancoNubank',
    category: 'Bancos',
    updatedAt: '20/06/2026',
    url: 'https://nubank.com.br',
  },
  {
    id: 'pwd_004',
    organizationId: 'org_3la_labs',
    service: 'Instagram 3LA Labs',
    username: '@3lalabs',
    password: 'Demo@SocialIG26',
    category: 'Redes sociais',
    updatedAt: '01/09/2026',
    url: 'https://instagram.com',
  },
  {
    id: 'pwd_005',
    organizationId: 'org_3la_labs',
    service: 'Google Workspace',
    username: 'admin@3lalabs.com.br',
    password: 'Demo@GoogleWS26',
    category: 'Serviços',
    updatedAt: '15/08/2026',
    url: 'https://admin.google.com',
  },
  {
    id: 'pwd_006',
    organizationId: 'org_3la_labs',
    service: 'API Stripe Sandbox',
    username: 'pk_test_demo_key',
    password: 'sk_test_demo_secret_key_xxxx',
    category: 'APIs',
    updatedAt: '30/07/2026',
    url: 'https://dashboard.stripe.com/test',
  },
  {
    id: 'pwd_007',
    organizationId: 'org_3la_labs',
    service: 'Notion Workspace',
    username: 'luan@3lalabs.com.br',
    password: 'Demo@Notion2026',
    category: 'Outros',
    updatedAt: '18/08/2026',
    url: 'https://notion.so',
  },
];

export const passwordCategories = [
  'Hospedagem',
  'Domínios',
  'Bancos',
  'Redes sociais',
  'Serviços',
  'APIs',
  'Outros',
];
